/** Shared card styles — cream + navy + gold (matches home hero) */
export const cardTheme = {
  shell:
    'bg-[#FAF7F0] rounded-2xl border border-[#E5DCCF] shadow-sm shadow-[#001848]/5 overflow-hidden',
  shellHover:
    'hover:border-[#C09048]/50 hover:shadow-md hover:shadow-[#001848]/8 transition-all duration-200',
  accentTop: 'border-t-4 border-t-[#C09048]',
  headerBanner: 'bg-gradient-to-br from-[#001848] via-[#001230] to-[#0C2448]',
  innerPanel:
    'bg-[#FAF7F0] rounded-t-2xl border border-[#E5DCCF] shadow-sm',
  feature:
    'bg-[#FAF7F0] rounded-2xl border border-[#E5DCCF] p-6 hover:border-[#C09048]/50 hover:shadow-md transition-all duration-200',
  courseCard:
    'bg-[#FAF7F0] rounded-2xl border border-[#E5DCCF] shadow-sm shadow-[#001848]/5 overflow-hidden hover:border-[#C09048]/50 hover:shadow-md hover:shadow-[#001848]/8 transition-all duration-200 h-full',
  title: 'text-[#001848] font-cairo-bold',
  subtitle: 'text-[#5A6B82]',
  badge:
    'inline-flex items-center gap-2 bg-[#EFE8DC] text-[#001848] border border-[#E5DCCF] px-3 py-1 rounded-full text-xs sm:text-sm font-semibold',
  badgeGold:
    'inline-flex items-center gap-2 bg-[#F8F1E4] text-[#A87824] border border-[#E0C99A]/80 px-3 py-1 rounded-full text-xs sm:text-sm font-semibold',
  btnPrimary:
    'bg-[#001848] hover:bg-[#001230] text-white font-semibold transition-colors',
  btnOutline:
    'border border-[#001848] text-[#001848] hover:bg-[#EFE8DC] font-semibold transition-colors',
  btnGold:
    'bg-[#C09048] hover:brightness-105 text-white font-semibold transition-colors',
  divider: 'bg-[#C09048]',
  price: 'text-[#001848] font-bold',
  iconBox: 'bg-[#001848] text-white',
  iconBoxGold: 'bg-[#C09048] text-white',
};
